import { InputHTMLAttributes, useEffect, useRef, useState } from 'react';

import styles from './style.module.scss';
import { t } from '@web-solutions/module-localization';
import { SearchIcon } from 'src/onboarding/assets/icons/SearchIcon';
import { CloseIcon } from 'src/onboarding/assets/icons/CloseIcon';
import { BackIcon } from 'src/onboarding/assets/icons/BackIcon';
import { ClearIcon } from 'src/onboarding/assets/icons/ClearIcon';

interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  showIcon?: boolean;
  placeholder?: string;
  onActivate?: () => void;
  onDeactivate?: () => void;
  active?: boolean;
  onChangeValue?: (value: string) => void;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  className = '',
  showIcon = true,
  placeholder,
  onActivate,
  onDeactivate,
  active: activeProp,
  ...props
}) => {
  const [internalActive, setInternalActive] = useState(false);
  const active = activeProp ?? internalActive;
  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (active) {
      inputRef.current?.focus();
    }
  }, [active]);

  return (
    <div className={`${styles.searchInputWrapper} ${active ? styles.active : ''}`}>
      {active && <div className={styles.overlay} />}
      {active && (
        <div
          className='back'
          onClick={() => {
            if (!activeProp) setInternalActive(false);
            onDeactivate?.();
          }}
        >
          <BackIcon />
        </div>
      )}
      <div className={`${styles.inputContainer} ${active ? styles.active : ''}`}>
        {showIcon && (
          <div className={styles.searchIcon}>
            <SearchIcon />
          </div>
        )}
        <input
          ref={inputRef}
          placeholder={t('onboarding.common.search')}
          onFocus={() => {
            if (!activeProp) setInternalActive(true);
            onActivate?.();
          }}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            props.onChangeValue?.(e.target.value);
          }}
          className={`${styles.searchInput} ${showIcon ? styles.searchInputWithIcon : ''}`}
          {...props}
        />

        {value.length > 0 && (
          <div className={styles.clearBtn} onClick={() => setValue('')}>
            <ClearIcon />
          </div>
        )}

        {active && (
          <div
            className={styles.closeBtn}
            onClick={() => {
              if (!activeProp) setInternalActive(false);
              onDeactivate?.();
            }}
          >
            <CloseIcon />
          </div>
        )}
      </div>
    </div>
  );
};
